import { Modal } from '../../../components/others/Modal'
import { PrimaryButton } from '../../../components/others/ButtonPrimary';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../../hooks';

type MProps = {
    show: boolean;
    urlTittle: string;
    onClose: () => void;
};

const CoordinatesErrorModal = ({
    show,
    urlTittle,
    onClose,
}: MProps) => {
    const { closeModal } = useModal()
    const navigate = useNavigate()

    const onEditEmployee = () => {
        closeModal("modalSolicitarAusentismo")
        onClose()
        return navigate(`/Empleados`)
    }

    return (
        <Modal
            show={show}
            urlTittle={urlTittle}
            modalContainerStyle="text-2xl text-red-500 font-bold"
            onClose={onClose}
        >
            <div className='flex flex-col w-auto justify-center align-middle mx-auto'>
                <div className='flex flex-col w-auto text-center align-middle'>
                    <span className='w-20 h-20 text-center flex justify-center mx-auto my-4' >
                        <svg width="40" height="50" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.6434 35.7143C21.1227 35.7143 22.322 34.5151 22.322 33.0357C22.322 31.5564 21.1227 30.3572 19.6434 30.3572C18.1641 30.3572 16.9648 31.5564 16.9648 33.0357C16.9648 34.5151 18.1641 35.7143 19.6434 35.7143Z" fill="#E1726F" />
                            <path d="M17.8594 8.92871H21.4308V25.0001H17.8594V8.92871Z" fill="#E1726F" />
                            <path d="M19.6429 50L4.57859 32.2339C4.36927 31.9672 4.16212 31.6987 3.95716 31.4286C1.38391 28.0389 -0.00621641 23.8986 2.0898e-05 19.6429C2.0898e-05 14.4332 2.06953 9.43701 5.75328 5.75326C9.43703 2.06951 14.4333 0 19.6429 0C24.8525 0 29.8487 2.06951 33.5325 5.75326C37.2162 9.43701 39.2857 14.4332 39.2857 19.6429C39.292 23.8967 37.9025 28.0351 35.3304 31.4232L35.3286 31.4286C35.3286 31.4286 34.7929 32.1321 34.7125 32.2268L19.6429 50ZM6.80716 29.2768C6.81074 29.2768 7.22502 29.8268 7.31966 29.9446L19.6429 44.4786L31.9822 29.925C32.0607 29.8268 32.4786 29.2732 32.4804 29.2714C34.5824 26.502 35.7184 23.1197 35.7143 19.6429C35.7143 15.3804 34.0211 11.2926 31.0071 8.27864C27.9931 5.26466 23.9053 3.57143 19.6429 3.57143C15.3805 3.57143 11.2926 5.26466 8.27866 8.27864C5.26468 11.2926 3.57145 15.3804 3.57145 19.6429C3.5677 23.1219 4.70498 26.5061 6.80895 29.2768H6.80716Z" fill="#E1726F" />
                        </svg>
                    </span>
                    <h2 className='text-[#444444] font-bold text-center mx-auto my-4'>El empleado no tiene la ubicación <br /> geolocalizada</h2>
                    <span className='text-[#444444] text-[14px] my-4'>Edita al empleado para cargar la geolocalización</span>
                </div>
                <div className='flex justify-center align-middle'>
                    <PrimaryButton
                        type='button'
                        text='Ir a editar Empleado'
                        onClick={onEditEmployee}
                        styles='bg-red-400 font-bold text-[#FFFFFF] mt-8 border-red-500 border w-auto hover:bg-red-500'
                    />
                </div>
            </div>
        </Modal>
    )
}

export default CoordinatesErrorModal